import React from "react";
import { Container } from "react-bootstrap";
import Calculator from "../../../payment-calculator/calculator/calculator";
import {submitDataForFlowApplication} from "../../utils/form-submission";
import {FLOW_NAMES} from "../../../enums/flows";

export async function submitEstimatePaymentStep(data, flowStore) {
   try{
      const response = await submitDataForFlowApplication(FLOW_NAMES.LEAD_FIRST, data);
      if (response.success) {
            const flowStepName = response.data['step_name'];

            console.info('Submit Estimate Payment')
            flowStore.handleStepRedirection(flowStepName);
      } else {
            console.error(`Server error ${response.status} body: ${response.data}`);
      }
   } catch (error){
      console.error(`Submit Estimate Payment error: ${error}`)
   }
}

export const EstimatePaymentStep = ({
   aprBounds,
   termMonths,
   vehiclePrice,
   preselectedCreditRange,
   flowStore,
   applicationUuid,
   docFee,
   disclosure,
   cashDownPayment,
   themeStore,
   }) => {

      const getData = (lastState) => {
         return {
            flow_uuid: applicationUuid,
            calculator_credit_rating: lastState.label,
            calculator_downpayment: lastState.downPayment,
            calculator_payment_range: lastState.paymentRange.from + '-' + lastState.paymentRange.to,
            calculator_term_length: lastState.term,
            calculator_vehicle_sales_price: lastState.price,
         }
      }

      const handlePrimaryAction  = (lastState) => {
         const data = getData(lastState);
         submitEstimatePaymentStep(data, flowStore);
       }

   return (
      <Container data-oid="estimate-payment-container">
         <Calculator
            salesPrice={{
               price: vehiclePrice,
               min: 2000,
               max: vehiclePrice,
            }}
            creditScoreSlots={[
               { label: "<640", aprLowerBound: aprBounds["640_lower_apr"], aprUpperBound: aprBounds["640_upper_apr"] },
               { label: "640-700", aprLowerBound: aprBounds["640_700_lower_apr"], aprUpperBound: aprBounds["640_700_upper_apr"] },
               { label: "700-780", aprLowerBound: aprBounds["700_780_lower_apr"], aprUpperBound: aprBounds["700_780_upper_apr"] },
               { label: "780+", aprLowerBound: aprBounds["780_lower_apr"], aprUpperBound: aprBounds["780_upper_apr"] },
            ]}
            terms={[48, 60, 72, 84]}
            preselectedCreditScoreSlot={preselectedCreditRange}
            preselectedTerm={termMonths}
            primaryAction={{
               label: "Get Prequalified",
               callback: handlePrimaryAction,
            }}
            docFee={docFee}
            disclosure={disclosure}
            cashDownPayment={cashDownPayment}
            themeStore={themeStore}
         />
      </Container>
   );
};

export default EstimatePaymentStep;
